import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/src/app/(frontend)/(accounts)/forgot-password/_components/ForgotPassword.tsx");
